import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Profile({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 15.0854 3.39732 17.8444 5.59365 19.6788C7.22458 18.0262 9.49272 17 12 17C14.5073 17 16.7754 18.0262 18.4064 19.6788C20.6027 17.8444 22 15.0854 22 12C22 6.47715 17.5228 2 12 2ZM12 22C10.2965 22 8.6924 21.574 7.28854 20.8228C8.53294 19.6894 10.1857 19 12 19C13.8143 19 15.4671 19.6894 16.7115 20.8228C15.3076 21.574 13.7036 22 12 22ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 4C9.79086 4 8 5.79086 8 8V11C8 13.2091 9.79086 15 12 15C14.2091 15 16 13.2091 16 11V8C16 5.79086 14.2091 4 12 4ZM10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8V11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11V8Z"
        fill={iconColor}
      />
    </Svg>
  );
}
